import { ReactNode, createContext, useReducer, useMemo } from 'react'
import { State } from './types'
import { initialState, reducer } from './index'

export const CreateDatasetContext = createContext<{
  state: State
  dispatch: React.Dispatch<any>
}>({
  state: initialState,
  dispatch: () => {
    // do nothing
  },
})

interface Props {
  children: ReactNode
}

const defaultState: State = {
  ...initialState,
  subTitle: 'Create Submission',
}

export const CreateDatasetProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer<React.Reducer<State, any>>(
    (state, action) => reducer(state, action) as State,
    defaultState,
  )
  const value = useMemo(() => ({ state, dispatch }), [state, dispatch])

  return <CreateDatasetContext.Provider value={value}>{children}</CreateDatasetContext.Provider>
}
